
@if (isExporting$ | async) {
  <button mat-stroked-button
          [disabled]="true">
    @if (useProgressSpinner$ | async) {
      <mat-progress-spinner diameter="20" color="primary" [value]="extractProgress$ | async"></mat-progress-spinner>
    } @else {
      <mat-spinner diameter="20" color="primary"></mat-spinner>
    }
  </button>
} @else if (showExportButton$ | async) {
  <button mat-stroked-button
          #exportButton
          [matMenuTriggerFor]="exportMenu">
    <span i18n="@@core.attribute-list.export">Export</span>
    <mat-icon iconPositionEnd svgIcon="drop_down"></mat-icon>
  </button>
}

<mat-menu #exportMenu="matMenu">
  @if (isFormatSupported$(supportedFormats.GEOJSON) | async) {
    <button
      mat-menu-item
      (click)="onExportClick(supportedFormats.GEOJSON)"
    i18n="@@core.common.geojson">GeoJSON</button>
  }
  @if (isFormatSupported$(supportedFormats.CSV) | async) {
    <button
      mat-menu-item
      (click)="onExportClick(supportedFormats.CSV)"
    i18n="@@core.common.csv">CSV</button>
  }
  @if (isFormatSupported$(supportedFormats.XLSX) | async) {
    <button
      mat-menu-item
      (click)="onExportClick(supportedFormats.XLSX)"
    i18n="@@core.common.excel">Excel</button>
  }
  @if (isFormatSupported$(supportedFormats.SHAPE) | async) {
    <button
      mat-menu-item
      (click)="onExportClick(supportedFormats.SHAPE)"
    i18n="@@core.common.shapefile">Shapefile</button>
  }
  @if (isFormatSupported$(supportedFormats.GEOPACKAGE) | async) {
    <button
      mat-menu-item
      (click)="onExportClick(supportedFormats.GEOPACKAGE)"
      i18n="@@core.common.geopackage">GeoPackage</button>
  }
  @if (isFormatSupported$(supportedFormats.DXF) | async) {
    <button
      mat-menu-item
      (click)="onExportClick(supportedFormats.DXF)"
      i18n="@@core.common.dxf">DXF</button>
  }
</mat-menu>
